import { render, staticRenderFns } from "./ApproverDialog.vue?vue&type=template&id=d2c4fc78&scoped=true&"
import script from "./ApproverDialog.js?vue&type=script&lang=js&"
export * from "./ApproverDialog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c4fc78",
  null
  
)

export default component.exports